<template>
  <div id="room-video" 
    v-if="this.roomObject" :class="{ 
    live : livestreamSettings != undefined,
    residency1 : residencySettings != undefined && residencySettings.edition == 'shiyundeng'
  }">
    <div v-if="roomConnection != null">
      <!-- Organizer container for initial video placement -->

      <div v-if="this.roomObject.YCTingResidency">

        <YCTingResidency 
          @changeRoom="changeRoom()"
          :roomConnection="roomConnection"
          :loading="loading"
          :cameraOptions="cameraOptions"
          :reRender="reRender"
          :reRenderRemoteAudio="reRenderRemoteAudio"
          :roomObject="roomObject"
          :username="username"
        />

      </div>

      <div v-else >
        <ResidencyVideoElem v-if="residencySettings != undefined && residencySettings.edition == 'shiyundeng'"/>
        <div id="video_container">
          <div 
            v-if="livestreamSettings != undefined"
            id="externalStream"
          >
            <ExternalStream
              :stream="externalStream"
            />
          </div>
          
          <!-- Local Video Tracks -->
          <div :key="'localvideo-' + reRenderLocal">
            <div
              v-for="(track, t_index) in roomConnection.localParticipant.videoTracks"
              :key="'localvideo-' + track.key"
            >
              <Videotrack
                :participantkey="'you'"
                :publication="track"
                :screenTrack="screenTrack"
                :trackindex="t_index"
              />
            </div>
          </div>

          <!-- Remote Video Tracks -->
          <div :key="'remotevideo-' + reRenderRemote">
            <div
              v-for="(participant, p_index) in roomConnection.participants"
              :key="'participant-' + participant.key"
            >
              <div
                v-for="(track, t_index) in participant[1].videoTracks"
                :key="'remotevideotrack-' + track.key"
              >
                <Videotrack
                  v-if="track[1].isSubscribed"
                  :participantkey="participant[1].username"
                  :publication="track"
                  :trackindex="calculateRemoteIndex(p_index, t_index)"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- Local Audio Tracks -->
        <div :key="'localaudio-' + reRenderLocalAudio">
          <div
            v-for="track in roomConnection.localParticipant.audioTracks"
            :key="'localaudiotrack-' + track.key"
          >
            <Audiotrack :participantkey="'you'" :publication="track" />
          </div>
        </div>

        <!-- Remote Audio Tracks -->
        <div :key="'remoteaudio-' + reRenderRemoteAudio">
          <div
            v-for="participant in roomConnection.participants"
            :key="'participantaudio-' + participant.key"
          >
            <div v-for="track in participant[1].audioTracks" :key="'remoteaudiotrack-' + track.key">
              <Audiotrack
                v-if="track[1].isSubscribed"
                :participantkey="participant[1].identity"
                :publication="track"
              />
            </div>
          </div>
        </div>

        <div
          id="box_organiser_right"
          :class="{ live : livestreamSettings != undefined}"
        >
          <Chatbox
            v-if="this.roomObject.chat"
            :username="this.username"
            class="menuBlock"
            :activeRoom="this.roomObject"
            :l="livestreamSettings != undefined"
          />
          <Linkblok
            v-if="roomObject.linkSharing"
            :username="this.username"
            :activeRoom="this.roomObject"
            class="menuBlock"
          />
          <FileUpload
            v-if="backgroundImageSettings != undefined && backgroundImageSettings.backgroundImageSharing == true"
            @uploaded-new-image="rerenderImage"
            class="menuBlock"
          />
          <Pad 
            v-if="etherpadSettings != undefined"
            class="menuBlock" :url="etherpadSettings.url"
          />
        </div>
        
        <BackgroundImage v-if="backgroundImageSettings != undefined && backgroundImageSettings.backgroundImageSharing == true" :key="fileUploadKey"/>

        <div 
          id="box_organiser_bottom"
          :class="{ live : livestreamSettings != undefined}"
        >
          <!-- Options window with Camera, Microphone and Screenshare options, only visible when openParticipation is set to true -->
          <div
            id="options"
            v-if="roomObject.audioVideoParticipation"
            class="menuBlock"
          >
            <p id="options-handle">Options</p>
            <div id="options-content">
              
              <div style="
                display:flex;
                flex-direction: row;
                height: calc(33% - 10px);
                width:100%;
              ">
                <button
                  v-on:click="turnOnCamera()"
                  :class="{ published: localCamera != null }"
                  :disabled='cameraButtonDisabled'

                  style="
                    height: 100%;
                    margin-right:0;
                    margin-bottom:0px;
                  "
                >
                  {{ cameraMessage }}
                </button>
                <button
                  v-if="isCameraOn"
                  v-on:click="toggleCameraSelector()"

                  style="
                    position: relative;
                    width: 15%;
                    right:0px;
                    top: 0;
                    margin-left:0;
                    cursor:pointer;
                    height: calc(33% -10px);
                    margin-bottom:0px;
                  "
                >></button>
              </div>

              <div
                id="camera-list"
                class="menuBlock"
                style="
                  background-color: var(--default-windows-bg-color);
                  z-index: 10010;
                  border: var(--invisible-windows-border);
                  position:fixed;
                  margin-left:200px;
                  margin-top:-50px;
                "
                v-if="showCameraSelector"
              >
                <p 
                id="camera-handle"
                style="
                  font-size: var(--button-font-size);
                  padding: 6px;
                  border-bottom: var(--default-border);
                  position:relative;
                "
                >Select camera</p>
                   <select id="video-devices" @change="onChange($event)"  >
                    <option v-for="option in cameraOptions" :key="option.name">
                      {{ option.name }}
                    </option>
                  </select>
              </div>

            <div style="
                display:flex;
                flex-direction: row;
                height: calc(33% - 10px);
                width:100%;
              ">
              <button
                v-on:click="turnOnMic()"
                :class="{ published: localMic != null }"
                style="
                  height: 100%;
                  margin-right:0;
                  margin-bottom:0px;
                  "
              >
                {{ micMessage }}
              </button>
              <button
                  v-if="isMicOn"
                  v-on:click="toggleMicSelector()"

                  style="
                    position: relative;
                    width: 15%;
                    right:0px;
                    top: 0;
                    margin-left:0;
                    cursor:pointer;
                    height: calc(33% -10px);
                    margin-bottom:0px;
                  "
                >></button>
              </div>

              <div
                id="mic-list"
                class="menuBlock"
                style="
                  background-color: var(--default-windows-bg-color);
                  z-index: 10010;
                  border: var(--invisible-windows-border);
                  position:fixed;
                  margin-top:-100px;
                  margin-left:200px;
                "
                v-if="showMicSelector"
              >
                <p 
                id="mic-handle"
                style="
                  font-size: var(--button-font-size);
                  padding: 6px;
                  border-bottom: var(--default-border);
                  position:relative;
                "
                >Select microphone</p>
                   <select id="mic-devices" @change="onChange($event)"  >
                    <option v-for="option in microphoneOptions" :key="option.name">
                      {{ option.name }}
                    </option>
                  </select>
              </div>

              <!-- <select v-if="isMicOn" id="mic-devices" @change="onChange($event)" >
                <option v-for="option in microphoneOptions" :key="option.name">
                  {{option.name}}
                </option>
              </select> -->


              <button
                v-on:click="shareScreen()"
                :class="{ published: screenTrack != null }"
                :disabled="false"
              >
                {{ screenShareMessage }}
              </button>
            </div>
          </div>
          
          <Participants
            :key="reRenderParticipantList"
            :participantlist="roomConnection.participants"
            :roomConnection="roomConnection"
            :loading="loading"
            @changeRoom="changeRoom()"
            class="menuBlock"
            :l="livestreamSettings != undefined"
            :residency1="residencySettings != undefined && residencySettings.edition == 'shiyundeng'"
          />

          <!-- <Location 
            v-if="this.roomObject.YCTingResidency"
            :activeRoom="this.roomObject"
            :username="this.username"
          /> -->

        </div>
        
      </div>

    </div>

  </div>

</template>

<script>
// copy of store to get authentication value
import store from '../store.js'
import interactions from "../interactions";

import { EventBus } from "../Event";
import Twilio, {
  connect,
  createLocalTracks,
  createLocalVideoTrack,
  createLocalAudioTrack,
} from "twilio-video";
import axios from "axios";
import assert from "assert";
import Participants from "./Participants";
import Linkblok from "./Linkblok";
import FileUpload from "./FileUpload";
import BackgroundImage from "./BackgroundImage";
import Chatbox from "./Chatbox";
import Pad from "./Pad";
import Audiotrack from "./Audiotrack";
import Videotrack from "./Videotrack";
import ExternalStream from "./ExternalStream";
import StreamService from '../StreamService'
import ResidencyVideoElem from './ResidencyVideoElem'
// import Location from './ResidencyYCTing/Location'
import Sphere from './ResidencyYCTing/Sphere'
import YCTingResidency from './ResidencyYCTing/YCTingResidency'


export default {
  name: "Room",
  data() {
    return {
      activeRoom: null,
      cameraButtonDisabled: false,
      cameraMessage: "Turn on camera",
      cameraOptions:[],
      externalStream: null,
      fileUploadKey: 0,
      fold: false,
      identity: "",
      isCameraOn: false,
      isMicOn: false,
      loading: false,
      localCamera: null,
      localIndex: 0,
      localMic: null,
      localTrack: false,
      micMessage: "Turn on microphone",
      microphoneOptions:[],
      previewTracks: "",
      reRender: 0,
      reRenderLocal: 0,
      reRenderLocalAudio: 0,
      reRenderParticipantList: 0,
      reRenderRemote: 0,
      reRenderRemoteAudio: 0,
      remoteIndex: null,
      remoteTrack: false,
      roomConnection: null,
      roomObject: null,
      screenShareMessage: "Share screen",
      screenStream: null,
      screenTrack: null,
      sharingScreen: false,
      showCameraSelector:false,
      showMicSelector:false,
      x: null,
      y: null,
    }
  },
  components: {
    Linkblok,
    Participants,
    FileUpload,
    BackgroundImage,
    Chatbox,
    Pad,
    Audiotrack,
    Videotrack,
    ExternalStream,
    ResidencyVideoElem,
    // Location,
    // Sphere,
    YCTingResidency
  },
  async beforeRouteEnter(to, from, next) {
    // router checks if user is authenticated to enter the room, if not, being redirected to login
    let auth = await store.state.authenticated;
        if (auth) {
          next();
        } else {
           next({ path: "/room/" + to.params.slug });  // back to safety route //
        }
    },
  created() {
    // get room information based on slug
    this.getRoomObjectData();

    StreamService.getStream()
      .then((stream) => {
        // console.log('STREAM: ', stream) 
        this.externalStream = stream
      })
  },
  mounted() {
    // When a user is about to transition away from this page,
    // disconnect from the room, if joined.
    window.addEventListener("beforeunload", this.leaveRoomIfJoined);

    // draggable script, still to get packed in external js
    interactions.dragDrop(
      "#options",
      "#options-handle",
      this.x,
      this.y
    );
  },
  computed: {
    username() {
      return this.$store.state.username
    },
    userHash() {
      return this.$store.state.userHash
    },
    livestreamSettings() {
      let found = this.roomObject.roomoptions.find(element => element.__component === 'room-options.livestream');
      return found;
    },
    residencySettings() {
      let found = this.roomObject.roomoptions.find(element => element.__component === 'room-options.residency');
      return found;
    },
    etherpadSettings() {
      let found = this.roomObject.roomoptions.find(element => element.__component === 'room-options.etherpad');
      return found;
    },
    backgroundImageSettings() {
      let found = this.roomObject.roomoptions.find(element => element.__component === 'room-options.background-image');
      return found;
    }
  },
  beforeUpdate() {
    this.$children.forEach((child) => {
      if (child.publication != undefined) {
        this.roomConnection.localParticipant.tracks.forEach((track) => {
          if (child.publication[0] == track.trackSid) {
            track.x = child.x;
            track.y = child.y;

            if (child.$el.style.width) {
              track.width = child.$el.style.width;
              track.height = child.$el.style.height;
            }
          }
        });

        this.roomConnection.participants.forEach((participant) => {
          // all the other participants
          participant.tracks.forEach((track) => {
            // tracks of all the other participants

            if (child.publication[0] == track.trackSid) {
              track.x = child.x;
              track.y = child.y;

              if (child.$el.style.width) {
                track.width = child.$el.style.width;
                track.height = child.$el.style.height;
              }
            }
          });
        });
      }
    });
    
    this.roomConnection.participants.forEach((participant) => {
      const usernameWithoutUserhash = participant.identity.split('---USERHASH---');
      participant.username = usernameWithoutUserhash[0];
    });

  },
  sockets: {
    streamUpdate(stream) {
      this.externalStream = stream;
    },
  },
  methods: {
    async getRoomObjectData() {
      let room = await axios
      .get(
        `https://api.enter.hetnieuweinstituut.nl/rooms?slug=${this.$route.params.slug}`
      )
      .then((res) => {
        return res.data[0];
      });
      this.roomObject = room;
      this.enterChat(room);
    },
    gotDevices(mediaDevices){
      const VueThis = this;
      let count = 1; 
      mediaDevices.forEach(mediaDevice => {
        if (mediaDevice.kind === 'videoinput') {
          const label = mediaDevice.label || `Camera ${count  }`;
          const deviceId = mediaDevice.deviceId
          const thisLabel = {name:label,deviceId}
          this.cameraOptions.push(thisLabel)
        }
      });

      navigator.mediaDevices.ondevicechange = function(event) {
        VueThis.updateDeviceList();
      }

    },

    toggleCameraSelector(){
      this.showCameraSelector = !this.showCameraSelector;
    },

    toggleMicSelector(){
      this.showMicSelector = !this.showMicSelector;
    },

    updateDeviceList(){  // Maybe it's a little much that I do this in gotDevices, and in updateDeviceList. They're almost doing the same thing
      const VueThis = this;
      VueThis.cameraOptions = [];
      VueThis.microphoneOptions = [];
      navigator.mediaDevices.enumerateDevices()
      .then(function(devices){
        let count = 1; 
        devices.forEach(function(device){
          if (device.kind === 'videoinput') {
            const label = device.label || `Camera ${count  }`;
            const deviceId = device.deviceId
            const thisLabel = {name:label,deviceId}
            VueThis.cameraOptions.push(thisLabel)
          }
          if(device.kind === 'audioinput'){
            const label = device.label || `audio ${count }`;
            const deviceId = device.deviceId;
            const thisLabel = {name:label,deviceId};
            VueThis.microphoneOptions.push(thisLabel);
          }

        })
      })
    },

    onChange(event){
      console.log(event.srcElement.id);

      if(event.srcElement.id  === 'mic-devices'){
        if(this.isMicOn){
          this.localMic.stop();
          this.showMicSelector = false;
          this.roomConnection.localParticipant.unpublishTrack(this.localMic);
        }

        navigator.mediaDevices.enumerateDevices().then(devices=>{
          const audioInput = devices.find(device => device.label === event.target.value);
          return createLocalTracks({ audio: { deviceId: audioInput.deviceId }});
          
        }).then((localTracks) => {
          this.roomConnection.localParticipant.publishTrack(localTracks[0]);
          this.localMic = localTracks[0];
          setTimeout(function () {
            this.micMessage = "Turn off microphone";
            this.isMicOn = true;
            this.reRenderLocalAudio += 1;
            this.updateDeviceList();
          }.bind(this), 1000);
        });
      }

      else{
        if(this.isCameraOn){
          this.localCamera.stop();
          this.roomConnection.localParticipant.unpublishTrack(this.localCamera);
        }
        navigator.mediaDevices.enumerateDevices().then(devices => {
          const videoInput = devices.find(device => device.label === event.target.value);
          return createLocalTracks({ audio: false, video: { deviceId: videoInput.deviceId } });
        }).then(localTracks => {
            this.localIndex += 1;
            this.roomConnection.localParticipant.publishTrack(localTracks[0]);
            this.localCamera = localTracks[0];
            this.showCameraSelector = false;
            setTimeout(function () {
              this.reRenderLocal += 1;
              this.reRender += 1;
              this.isCameraOn = true;
            }.bind(this), 1000);
        })

      }


      
    },
    
    calculateRemoteIndex(p_index, t_index) {
      return p_index + t_index + 2;
    },
    turnOnCamera() {
      const VueThis = this;
      if (VueThis.localCamera == null) {
        // createLocalVideoTrack().then((track) => {
        VueThis.cameraButtonDisabled = true;
        createLocalTracks({ audio: false, video: { deviceId: this.cameraOptions[0].deviceId } }).then((track) => {
          VueThis.localIndex += 1;
          VueThis.roomConnection.localParticipant.publishTrack(track[0]);
          VueThis.localCamera = track[0];
          setTimeout(function () {
            VueThis.reRenderLocal += 1;
            VueThis.reRender += 1;
            VueThis.cameraMessage = "Turn off camera";
            VueThis.isCameraOn  = true;
            VueThis.cameraButtonDisabled = false;
            VueThis.updateDeviceList();
          }, 1000);
        });
      } else {
        this.turnOffCamera();
      }
      
    },

    turnOffCamera() {
      const VueThis = this;
      VueThis.cameraMessage = "Turn on camera";
      VueThis.localCamera.stop();
      VueThis.roomConnection.localParticipant.unpublishTrack(VueThis.localCamera);
      VueThis.localCamera = null;
      VueThis.reRenderLocal += 1;
      // VueThis.reRender += 1;
      VueThis.isCameraOn = false;
      VueThis.showCameraSelector = false;
    },

    turnOnMic() {
      const VueThis = this;
      if (VueThis.localMic == null) {
        createLocalAudioTrack().then((track) => {
          VueThis.roomConnection.localParticipant.publishTrack(track);
          VueThis.localMic = track;
          setTimeout(function () {
            VueThis.micMessage = "Turn off microphone";
            VueThis.isMicOn = true;
            VueThis.reRenderLocalAudio += 1;
            VueThis.updateDeviceList();
          }, 1000);
        });
      } else {
        this.turnOffMic();
      }
    },

    turnOffMic() {
      const VueThis = this;
      VueThis.micMessage = "Turn on microphone";
      VueThis.roomConnection.localParticipant.unpublishTrack(VueThis.localMic);
      VueThis.localMic = null;
      VueThis.isMicOn = false;
      VueThis.reRenderLocalAudio += 1;
    },

    shareScreen() {
      const VueThis = this;
      let displayMediaStreamConstraints = {
        audio: false,
        video: true, // or pass HINTS
      };

      if (this.screenTrack == null) {
        if (navigator.mediaDevices.getDisplayMedia) {
          navigator.mediaDevices
            .getDisplayMedia(displayMediaStreamConstraints)
            .then(function (stream) {
              VueThis.screenStream = stream;
              VueThis.localIndex += 1;
              VueThis.screenTrack = stream.getVideoTracks()[0];
              VueThis.roomConnection.localParticipant.publishTrack(
                VueThis.screenTrack
              );
              setTimeout(function () {
                VueThis.reRenderLocal += 1;
                VueThis.reRender += 1;
                VueThis.screenShareMessage = "Stop screen share";
                VueThis.sharingScreen = true;
              }, 1000);
              stream
                .getVideoTracks()[0]
                .addEventListener("ended", () => VueThis.endScreenShare());
            });
        } else {
          navigator.mediaDevices
            .getDisplayMedia(displayMediaStreamConstraints)
            .then(
              (stream) =>
                function (stream) {
                  VueThis.screenStream = stream;
                  VueThis.screenTrack = stream.getVideoTracks()[0];
                  VueThis.roomConnection.localParticipant.publishTrack(
                    VueThis.screenTrack
                  );
                  setTimeout(function () {
                    VueThis.reRenderLocal += 1;
                    VueThis.reRender += 1;
                    // VueThis.screenShareMessage = "stop screen share";
                  }, 1000);
                  stream
                    .getVideoTracks()[0]
                    .addEventListener("ended", () => VueThis.endScreenShare());
                }
            );
        }
      } else {
        this.endScreenShare();
      }
    },
    endScreenShare() {
      this.screenShareMessage = "Share screen";
      this.sharingScreen = false;
      this.screenTrack.stop();
      this.roomConnection.localParticipant.unpublishTrack(this.screenTrack);
      this.screenTrack = null;
    },
    async getAccessToken() {
      return await axios.get(
        `https://video.enter.hetnieuweinstituut.nl/token?identity=${this.username}`
        // `http://localhost:3030/token?identity=${this.username}`
      );
    },

    // Trigger log events
    dispatchLog(message) {
      EventBus.$emit("new_log", message);
    },

    changeRoom() {
      const VueThis = this;
      VueThis.dispatchLog("");
      if (this.sharingScreen) {
        this.endScreenShare();
      }
      if (this.isMicOn) {
        this.turnOffMic();
      }
      if (this.isCameraOn) {
        this.turnOffCamera();
      }
      this.roomConnection.disconnect();
      this.$store.commit("authenticate", false);
      this.roomConnection = null;
      this.$router.push('/');
    },

    // Leave Room.
    leaveRoomIfJoined() {
      if (this.roomConnection) {
        this.roomConnection.disconnect();
        this.roomConnection.localParticipant.unpublishTrack(this.localCamera);
        this.roomConnection.localParticipant.unpublishTrack(this.localMic);
        this.roomConnection.localParticipant.unpublishTrack(this.screenTrack);
        this.$store.commit("authenticate", false);
      }
    },

    enterChat(room) {
      this.loading = true;
      const VueThis = this;
      VueThis.dispatchLog("Loading " + this.roomObject.name);

      navigator.mediaDevices.enumerateDevices().then(this.gotDevices); // this is to load in all the media devices ( camera and mic)

      // Settings on entering, immediate video and or audiostreaming when entering the room set to false. Option to keep track of the dominant speaker is currently disabled, but could be used for future features!
      var options = {
        name: this.roomObject.name,
        dominantSpeaker: false,
        audio: false,
        video: false,
      };

      this.getAccessToken().then((data) => {
        VueThis.roomName = null;
        const token = data.data.token;
        // Twilio.connect options die worden meegestuurd naar de API
        let connectOptions = options;
        // before a user enters a new room, disconnect the user from they joined already
        this.leaveRoomIfJoined();

        // Connect with room
        Twilio.connect(token, connectOptions).then(function (room) {
          // Set active toom
          if (VueThis.roomObject.maxParticipants == null || room.participants.size < VueThis.roomObject.maxParticipants) {
            VueThis.roomConnection = room;
            VueThis.loading = false;
            VueThis.dispatchLog(room.name);
          } else {
            room.disconnect();
            VueThis.$store.commit("authenticate", false);
            VueThis.$router.push("/room/" + VueThis.roomObject.slug);
            VueThis.dispatchLog("");
            VueThis.$store.commit("limitNotification", true);
          }

            // Register Participant who join the Room while you are in it
            // room.on("participantConnected", function (participant) {
            //   VueThis.reRenderParticipantList += 1;
            //   VueThis.reRender += 1;
            // });

            function trackPublished(publication, participant) {
              console.log(
                `RemoteParticipant ${participant.username} published a RemoteTrack: ${publication}`
              );
              console.log(publication, participant); 
              assert(!publication.isSubscribed);
              assert.equal(publication.track, null);

              publication.on("subscribed", (track) => {
                console.log(
                  `LocalParticipant subscribed to a RemoteTrack: ${track}`
                );
                assert(publication.isSubscribed);
                assert(publication.track, track);
                if (publication.kind == "video") {
                  VueThis.reRenderRemote += 1;
                  VueThis.reRender += 1;
                } else {
                  VueThis.reRenderRemoteAudio += 1;
                }
              });

              publication.on("unsubscribed", (track) => {
                console.log(
                  `LocalParticipant unsubscribed from a RemoteTrack: ${track}`
                );
                assert(!publication.isSubscribed);
                assert.equal(publication.track, null);
                if (publication.kind == "video") {
                  VueThis.reRenderRemote += 1;
                  VueThis.reRender += 1;
                } else {
                  VueThis.reRenderRemoteAudio += 1;
                }  
              });
            
          }

          function participantConnected(participant) {
            VueThis.reRenderParticipantList += 1;
            VueThis.reRender += 1;
            participant.tracks.forEach((publication) => {
              trackPublished(publication, participant);
            });

            participant.on("trackPublished", (publication) => {
              trackPublished(publication, participant);
            });

            participant.on("trackUnpublished", (publication) => {
              console.log(
                `RemoteParticipant ${participant.identity} unpublished a RemoteTrack: ${publication}`
              );
            });
          }

          room.participants.forEach(participantConnected);
          room.on("participantConnected", participantConnected);

          // When a Participant leaves the Room, detach its Tracks.
          room.on("participantDisconnected", function (participant) {
            VueThis.reRenderParticipantList += 1;
          });
        });
      });
    },

    rerenderImage() {
      this.fileUploadKey += 1;
    },
  },
};
</script>

<style lang="css">
#room-video {
  top: 0;
  width: 100%;
  height: 100%;
}

#room-video.residency1 {
  background-color:#0000ff;
}

/* placement organiser of the interface windows */
#box_organiser_right {
  position: absolute;
  width: 200px;
  height: calc(100% - 50px);
  right: 35px;
  margin-top: 35px;
}

#box_organiser_bottom {
  position: absolute;
  width: 400px;
  height: 190px;
  left: 25px;
  bottom: 25px;
}

/* styling of the interface windows */
#box_organiser_bottom > div, #box_organiser_right > div {
  background-color: var(--default-windows-bg-color);
  filter: var(--drop-shadow);
  border: var(--invisible-windows-border);
}

/* styling of the interface windows in the LIVE room*/
#box_organiser_bottom.live > div, #box_organiser_right.live > div {
  background-color: var(--liveroom-windows-bg-color);
  filter: var(--drop-shadow);
  border: var(--invisible-windows-border);
}

#box_organiser_right.live .bottom-sticky {
  background-color: var(--liveroom-windows-bg-color);
}

#box_organiser_bottom.live button,
#box_organiser_bottom.live label,
#box_organiser_right.live button,
#box_organiser_right.live label, {
  background-color: var(--liveroom-interface-button-bg-color);
}

#video_container {
  position: absolute;
  width: 80vw;
  height: 80vh;
  left: 5vw;
  top: 10vh;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

#video_container div {
  position: absolute;
  width: 250px;
  height: auto;
}

#options {
  position: absolute;
  background-color: var(--default-windows-bg-color);
  filter: var(--drop-shadow);
  border: var(--default-border);
  z-index: 10010;
}

#options-handle {
  position: sticky;
  margin-block-start: 0;
  margin-bottom: 0;
  font-size: var(--button-font-size);
  padding: 6px;
  border-bottom: var(--default-border);
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

#options-content {
  position: relative;
  width: 200px;
  height: 100%;
  min-height: 100px;
  margin-top: 3px;
  overflow-y: auto;
}

#options-content button {
  background-color: var(--options-button-bg-color);
}

#options-content button:hover {
  background-color: var(--default-interface-button-hover-bg-color) !important;
}

button.published {
  background-color: #2bf3aa !important;
}

button#changeRoom {
  position: sticky;
  bottom: 3vh;
  z-index: 10;
}

button:disabled {
  cursor: not-allowed;
  pointer-events: all !important;
}


/* #options-content select{
  display:none;
} */

</style>

